import { clsx } from 'clsx'
import toast from 'react-hot-toast'
import { twMerge } from 'tailwind-merge'

import currency from 'currency.js'
import _ from 'lodash'

export function formatCurrency(amount) {
  return amount && !_.isNaN(amount)
    ? currency(amount, { symbol: '$', precision: 0 }).format()
    : ''
}

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}
export const formatCountryName = (country) => {
  return country === 'United Kingdom'
    ? 'London, UK'
    : country === 'United States'
    ? 'Miami, USA'
    : country
}

export const notify = (
  type,
  message,
  position = 'top-center',
  delay = null,
) => {
  return toast[type](message, {
    position: position,
    className: 'toast-dark',
    // duration: delay ? delay : 5000
  })
}
const chipHtml = (chipData, className) => {
  return (
    <div
      className={twMerge(
        'bg-[#155eef] bg-opacity-[.23] flex items-center rounded-full text-center px-3 py-1 text-[#155EEF] font-medium text-sm truncate',
        className,
      )}
    >
      {chipData}
    </div>
  )
}
export default function CategoryBadge({ title, className = '' }) {
  return typeof title == 'string'
    ? chipHtml(title, className)
    : title?.length > 0 &&
        title?.map((data) => {
          return <>{chipHtml(data, className)}</>
        })
}
